export default {
	approved: 'Approval',
	rejected: 'Rejection',
	deferred: 'Deferral'
};



// WEBPACK FOOTER //
// ./src/data/finalisationLabelMap.js